
import PrintPositionsManager from '../../../print-positions-manager-v2/print-positions-manager-v2.vue';
import { useStore as useProductStore } from '@/stores/v2/product';
import { useStore as useLangStore } from '@/stores/v2/lang';
import Vue from 'vue';
import { mapState } from 'pinia';

export default Vue.extend({
  name: 'PrintPositionsModal',
  components: {
    PrintPositionsManager,
  },
  props: {
    sapCustomerId: {
      type: String,
      required: true,
    },
    editId: {
      type: String,
      required: false,
      default: '',
    },
    tok: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(useProductStore, [
      'selectedVariant',
      'unavailablePrintPositions',
    ]),
    ...mapState(useLangStore, ['languageInUse']),
  },
});
